var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page congrats"},[_c('img',{attrs:{"id":"hp","src":require("@/assets/images/zloy.png")}}),_c('br')])}]

export { render, staticRenderFns }